import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ExitToApp } from '@mui/icons-material';

import { dashboardPaths } from '../../../routes/dashboardPaths';
import { useAuth } from '../../../hooks/auth';

const ICON_COLOR = '#236A9F';
const ACTIVE_ICON_COLOR = '#DCDCDC';

export function MainListItems() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div>
      {dashboardPaths.map(item => {
        const ItemIcon = item.icon;
        return (
          <ListItem key={item.name} button onClick={() => navigate(item.name)}>
            <ListItemIcon>
              <ItemIcon
                style={{
                  color: pathname === item.name ? 'white' : ICON_COLOR,
                }}
              />
            </ListItemIcon>
            <ListItemText style={{ color: ACTIVE_ICON_COLOR }} primary={item.title} />
          </ListItem>
        );
      })}
    </div>
  );
}

export function SecondaryListItems() {
  const { signOut } = useAuth();

  return (
    <div>
      <ListItem button onClick={signOut}>
        <ListItemIcon>
          <ExitToApp style={{ color: ICON_COLOR }} />
        </ListItemIcon>
        <ListItemText style={{ color: '#DCDCDC' }} primary='Sair' />
      </ListItem>
    </div>
  );
}
